import { createReducer, on } from '@ngrx/store';
import { SealingElement } from 'src/app/models/sealing-element.model';
import * as fromActions from '../actions/sealing-element-maintenance.actions';
import { SealingElementMaintenanceFilter, StringMatcherSymbol } from './sealing-element.reducer';

export const sealingElementMaintenanceFeatureKey = 'sealingElementMaintenance';

export enum Loaders {
  loadSealingElements,
  loadSealingElementsLookups,
  exporting
}

export interface State {
  loaders: Loaders[];
  maintenance?: {
    value?: SealingElement[],
    count?: number,
    skip?: number,
    take?: number
  },
  filter: SealingElementMaintenanceFilter,
  selection: string[]
}

export const initialState: State = {
  loaders: [],
  filter: {
    partNumberMatcher: StringMatcherSymbol.StartsWith
  },
  selection: []
};

export const reducer = createReducer(
  initialState,
  // for the maintenance screen
  on(fromActions.loadSealingElementsForMaintenance, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.loadSealingElements),
    maintenance: {
      ...state.maintenance,
      skip: action.skip,
      take: action.take
    }
  })),

  on(fromActions.loadSealingElementsForMaintenanceSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(l => l !== Loaders.loadSealingElements),
    maintenance: {
      ...state.maintenance,
      value: action.data.value,
      count: action.data.count
    }
  })),
  on(fromActions.updateMaintenanceFilter, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(l => l !== Loaders.loadSealingElements),
    filter: JSON.stringify(action.obj) === '{}' ? {} : { // If an empty object is passed, we want to reset the whole filter
      ...state.filter,
      ...action.obj
    }
  })),
  on(fromActions.toggleSealingElementSelection, (state, action) => ({
    ...state,
    selection: state.selection.includes(action.partNumber) ? state.selection.filter(s => s !== action.partNumber) : state.selection.concat(action.partNumber)
  })),

  on(fromActions.exportToExcel, (state, action) => ({
    ...state,
    loaders: state.loaders.concat(Loaders.exporting)
  })),
  on(fromActions.exportToExcelSuccess, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(l => l !== Loaders.exporting)
  })),
  on(fromActions.exportToExcelFail, (state, action) => ({
    ...state,
    loaders: state.loaders.filter(l => l !== Loaders.exporting)
  })),
  on(fromActions.toggleAll, (state, action) => ({
    ...state,
    selection: state.selection.length === (state.maintenance?.value || []).length ?
      [] :
      ((state.maintenance || { value: [] })?.value || [])?.map(v => v.partNumber!)
  })),
  on(fromActions.clearSelection, (state, action) => ({
    ...state,
    selection: []
  }))
);
